import styled from 'styled-components'
import { Row, Form } from 'react-angle-dashboard-components'

export const EmployeeWrapper = styled.div`
  padding: 12px 20px;
  background-color: #fff;
  border: 1px solid #dee2e6;
  margin-bottom: 10px;
  border-radius: 4px;
`

export const EmployeeFirstRow = styled(Row)``

export const EmployeeNumber = styled.span`
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
`

export const InputLabel = styled.label`
  font-size: 14px;
  display: inline-block;
  margin-right: 5px;
`

export const EmployeeInput = styled(Form.Control)`
  height: 36px;
  margin-right: 30px;
  padding-right: 1px;
`

export const EmployeeSecondRow = styled(Row)`
  border-top: 1px solid #e7eaf3;
  padding-top: 20px;
  margin-top: 20px;
`
